import React from 'react';
import './presetsluts.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaInstagram, FaTiktok, FaFacebook, FaPinterest, FaTumblr, FaDeviantart } from 'react-icons/fa';


function PresetsLuts() {
  return (
    <div className="containerPresetsluts">
      <span className='titlePresetsluts'>Coming Soon!</span><br/>
      Here you can will find some pretty presets that you can use it in your pictures. Until then you can see me on my social media accounts:
      <br/>
      <a href="https://www.instagram.com/iulianamihai" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="iconPresetsluts" />
          </a>
          <a href="https://www.tiktok.com/@iuliana.mihai" target="_blank" rel="noopener noreferrer">
            <FaTiktok className="iconPresetsluts" />
          </a>
          <a href="https://www.facebook.com/IM.iulianamihai/" target="_blank" rel="noopener noreferrer">
            <FaFacebook className="iconPresetsluts" />
          </a>
          <a href="https://ro.pinterest.com/iulianamihaii/" target="_blank" rel="noopener noreferrer">
            <FaPinterest className="iconPresetsluts" />
          </a>
          <a href="https://www.tumblr.com/iulianamihaii" target="_blank" rel="noopener noreferrer">
            <FaTumblr className="iconPresetsluts" />
          </a>
          <a href="https://www.deviantart.com/nebunelli" target="_blank" rel="noopener noreferrer">
            <FaDeviantart className="iconPresetsluts" />
          </a>
    </div>
  );
}

export default PresetsLuts;